(function () {
  if (window.__rabitatFaqScriptLoaded) return;
  window.__rabitatFaqScriptLoaded = true;

  function wrapClusters(list) {
    if (!list || list.dataset.clustersWrapped === 'true') return;
    list.dataset.clustersWrapped = 'true';

    var child = list.firstElementChild;
    var ungrouped = [];

    function flushUngrouped() {
      if (!ungrouped.length) return;
      var cluster = document.createElement('div');
      cluster.className = 'rabitat-faq__cluster rabitat-faq__cluster--ungrouped';
      list.insertBefore(cluster, ungrouped[0]);
      ungrouped.forEach(function (el) {
        cluster.appendChild(el);
      });
      ungrouped = [];
    }

    while (child) {
      var next = child.nextElementSibling;

      if (child.classList.contains('rabitat-faq__group')) {
        flushUngrouped();
        var cluster = document.createElement('div');
        cluster.className = 'rabitat-faq__cluster';
        list.insertBefore(cluster, child);
        cluster.appendChild(child);
        child = next;

        while (child && child.classList.contains('rabitat-faq__item')) {
          next = child.nextElementSibling;
          cluster.appendChild(child);
          child = next;
        }
        continue;
      }

      if (child.classList.contains('rabitat-faq__item')) {
        ungrouped.push(child);
      }

      child = next;
    }

    flushUngrouped();
  }

  function initRoot(root) {
    if (!root || root.dataset.faqBound === 'true') return;
    root.dataset.faqBound = 'true';

    wrapClusters(root.querySelector('.rabitat-faq__list'));

    var items = Array.prototype.slice.call(root.querySelectorAll('.rabitat-faq__item'));
    if (!items.length) {
      root.setAttribute('data-faq-ready', 'true');
      return;
    }

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function getWrap(item) {
      return item.querySelector('.rabitat-faq__answer-wrap');
    }

    function setWrapHeight(wrap, height) {
      wrap.style.height = typeof height === 'number' ? height + 'px' : height;
    }

    function openItem(item, animate) {
      var wrap = getWrap(item);
      if (!wrap) return;

      item.setAttribute('open', '');

      if (!animate) {
        setWrapHeight(wrap, 'auto');
        return;
      }

      setWrapHeight(wrap, 0);
      window.requestAnimationFrame(function () {
        setWrapHeight(wrap, wrap.scrollHeight);
      });

      function onOpenEnd(event) {
        if (event.propertyName !== 'height') return;
        wrap.removeEventListener('transitionend', onOpenEnd);
        if (item.hasAttribute('open')) setWrapHeight(wrap, 'auto');
      }

      wrap.addEventListener('transitionend', onOpenEnd);
    }

    function closeItem(item, animate) {
      var wrap = getWrap(item);
      if (!wrap) return;

      if (!animate) {
        item.removeAttribute('open');
        setWrapHeight(wrap, 0);
        return;
      }

      setWrapHeight(wrap, wrap.scrollHeight);
      window.requestAnimationFrame(function () {
        setWrapHeight(wrap, 0);
      });

      function onCloseEnd(event) {
        if (event.propertyName !== 'height') return;
        wrap.removeEventListener('transitionend', onCloseEnd);
        item.removeAttribute('open');
        setWrapHeight(wrap, 0);
      }

      wrap.addEventListener('transitionend', onCloseEnd);
    }

    function closeOthers(activeItem, animate) {
      items.forEach(function (item) {
        if (item !== activeItem && item.hasAttribute('open')) {
          closeItem(item, animate);
        }
      });
    }

    items.forEach(function (item) {
      var summary = item.querySelector('.rabitat-faq__question');
      var wrap = getWrap(item);
      if (!summary || !wrap) return;

      if (item.hasAttribute('open')) {
        setWrapHeight(wrap, 'auto');
      } else {
        setWrapHeight(wrap, 0);
      }

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        var animate = !prefersReducedMotion;
        var isOpen = item.hasAttribute('open');

        if (isOpen) {
          closeItem(item, animate);
          return;
        }

        closeOthers(item, animate);
        openItem(item, animate);
      });
    });

    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        if (!item.hasAttribute('open')) return;
        var wrap = getWrap(item);
        if (!wrap || wrap.style.height === 'auto') return;
        setWrapHeight(wrap, wrap.scrollHeight);
      });
    });

    root.setAttribute('data-faq-ready', 'true');
  }

  function boot() {
    document.querySelectorAll('[data-rabitat-faq]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
